// extracted by mini-css-extract-plugin
export var copyableField = "_ly-4";
export var customerBadge = "_ly-0";
export var customerInfoTitle = "_ly-2";
export var details = "_ly-1";
export var dropdownContainer = "_ly-5";
export var dropdownImage = "_ly-6";
export var editAssigneeForm = "_ly-a";
export var editButton = "_ly-3";
export var email = "_ly-7";
export var hidden = "_ly-d";
export var input = "_ly-8";
export var saveButton = "_ly-b";
export var shopifyIcon = "_ly-c";
export var suggestionBadge = "_ly-e";
export var suggestionText = "_ly-f";
export var username = "_ly-9";